import { defineStore } from 'pinia'
import { ref } from 'vue'
import * as oddsService from '@/api/oddsService'
import type { User } from '@/types/user'

export const useUsersStore = defineStore('users', () => {
  const user = ref<User | null>(null)

  const isLoading = ref(false)
  const error = ref<string | null>(null)

  async function saveUser(username: string) {
    isLoading.value = true
    error.value = null
    try {
      if (!user.value) throw new Error('User is not loaded')
      user.value.username = username
      await oddsService.updateUser(user.value)
    } catch (err: any) {
      error.value = err.message || 'Failed to save preferences'
    } finally {
      isLoading.value = false
    }
  }

async function deleteUser() {
  isLoading.value = true
  error.value = null
  try {
    if (!user.value) throw new Error('User is not loaded')
    await oddsService.deleteUser(user.value.userId)
  } catch (err: any) {
    error.value = err.message || 'Failed to load preferences'
    throw err
  } finally {
    isLoading.value = false
  }
}

async function unlinkProvider(provider: any) {
  isLoading.value = true
  error.value = null
  try {
    if (!user.value) throw new Error('User is not loaded')
    await oddsService.unlinkProvider(provider)
  } catch (err: any) {
    error.value = err.message || 'Failed to load preferences'
    throw err
  } finally {
    isLoading.value = false
  }
}

  function resetUser() {
    user.value = null
  }

  return {
    user,
    isLoading,
    error,
    saveUser,
    deleteUser,
    unlinkProvider,
    resetUser
  }
})